import { IconButton } from "@mui/material";
import { Fragment, useState } from "react";
import Image from "./Image.jsx";

const AdInfo = ({ data, fields }) => {
   console.log(fields , 'fieldsfields')
  const [open,setOpen] = useState()
  return (
    <div className="bg-white rounded-md py-3 md:px-10 px-4 flex flex-col gap-3">
      <div className="w-full pb-4 border=[#8F8F8F] border-b border-dashed flex flex-col md:flex-row md:justify-between gap-2 md:items-center">
        <div className="md:block flex justify-between">
          <div className="flex items-center gap-3">
            <img width={15} src="/images/icons/phone.svg" alt="phone" />
            <a
              href={"tel:+" + data?.contactNumber}
              className="font-bold text-[#147CAF] text-sm"
            >
              {data?.contactNumber}
            </a>
          </div>
          <IconButton sx={{ display: { md: "none", xs: "block" } }}>
            <img width={15} src="/images/icons/chat-black.svg" alt="chat" />
          </IconButton>
        </div>

        <div className="flex items-center gap-3">
          {data?.webSite && (
            <a href={data?.webSite} target="_blank" rel="noreferrer">
              <img width={15} src="/images/icons/website.svg" alt="website" />
              <span className="font-bold text-[#147CAF] text-sm">
                {data?.webSite}
              </span>
            </a>
          )}
        </div>
        <IconButton sx={{ display: { md: "block", xs: "none" } }}>
          <img width={15} src="/images/icons/chat-black.svg" alt="chat" />
        </IconButton>
      </div>
      <div className="flex flex-col gap-3 pt-3">
        <h2 className="font-bold text-sm text-[#4D4D4D]">{data?.title}</h2>
        <p className="text-sm text-[#4D4D4D]">{data?.description}</p>
        {/*  <p className="text-sm text-[#4D4D4D]">
          RNITURE, OR DECORATIVE OBJECT MADE AT AN EARLIER PERIOD AND ACCORDING
          TO VARIOUS CUSTOMS LAWS AT LEAST 100 YEARS AGO. B : A MANUFACTURED
          PRODUCT (SUCH AS AN AUTOMOBILE) FROM AN EARLIER PERIOD. ANTIQUE. VERB.
        </p> */}
      </div>
      <>
        <>
          {fields?.map((item) => (
            <Fragment key={Math.random()?.toString()}>
              {item?.fieldType === 7 && item?.value && (
                <div className="border my-4 border-dashed border-[#8F8F8F] p-4 grid grid-cols-2 gap-4">
                  {JSON.parse(item?.value)?.map((val, index) => (
                    <Fragment key={Math.random()?.toString()}>
                      {item?.values?.map((vals) => (
                        <Fragment key={Math.random()?.toString()}>
                          {Number(val) === Number(vals.id) && (
                            <div className="flex items-center gap-2">
                              <img
                                width={15}
                                src="/images/icons/done.svg"
                                alt="done"
                              />
                              <span className="text-sm text-[#4D4D4D]">
                                {vals?.title}
                              </span>
                            </div>
                          )}
                        </Fragment>
                      ))}
                    </Fragment>
                  ))}
                </div>
              )}
            </Fragment>
          ))}
        </>
      </>
      <div className="flex flex-col gap-3 w-full">
        {fields?.map((item, index) => (
          <Fragment key={Math.random()?.toString()}>
            {item?.fieldType === 1 ||
            item?.fieldType === 2 ||
            item?.fieldType === 15 ||
            item?.fieldType === 13 ? (
              <div className="grid grid-cols-2">
                <div className="flex items-center gap-3">
                  <Image width={18} id={item?.fieldGalleryId} alt="car" className={undefined} size={undefined} height={undefined} defualtWidth={undefined} />
                  <span className="text-sm text-[#4D4D4D]">
                    {item?.field} :{" "}
                  </span>
                </div>
                <h3 className="text-[#4D4D4D] text-sm font-bold">
                  {item?.value}{" "}
                </h3>
              </div>
            ) : item?.fieldType === 4 ||
              item?.fieldType === 5 ||
              item?.fieldType === 8 ? (
              <div className="grid grid-cols-2">
                <div className="flex items-center gap-3">
                  <Image width={18} id={item?.fieldGalleryId} alt="car" className={undefined} size={undefined} height={undefined} defualtWidth={undefined} />
                  <span className="text-sm text-[#4D4D4D]">
                    {item?.field} :{" "}
                  </span>
                </div>
                <h3 className="text-[#4D4D4D] text-sm font-bold">
                  {item?.values?.map((it) => (
                    <Fragment key={Math.random()?.toString()}>
                      {Number(it?.id) === Number(item?.value) && (
                        <>{it?.title}</>
                      )}
                    </Fragment>
                  ))}{" "}
                </h3>
              </div>
            ) : item?.fieldType === 10 ? (
              <div className="grid grid-cols-2">
                <div className="flex items-center gap-3">
                  <Image width={18} id={item?.fieldGalleryId} alt="car" className={undefined} size={undefined} height={undefined} defualtWidth={undefined} />
                  <span className="text-sm text-[#4D4D4D]">
                    {item?.field} :{" "}
                  </span>
                </div>
                <h3 className="text-[#4D4D4D] text-sm font-bold">
                  {item?.values?.map((it) => (
                    <Fragment key={Math.random()?.toString()}>
                      {Number(it?.id) === Number(item?.value) ? (
                        <div className="flex gap-1 items-center">
                          <div
                            style={{
                              width: "10px",
                              height: "10px",
                              background: it?.value,
                              borderRadius: "50%",
                            }}
                          ></div>
                          <span> {it?.title} </span>
                        </div>
                      ) : (
                        <></>
                      )}
                    </Fragment>
                  ))}{" "}
                </h3>
              </div>
            ) : item?.fieldType === 11? (
              <div className="grid grid-cols-2">
                <div className="flex items-center gap-3">
                  <Image width={18} id={item?.fieldGalleryId} alt="car" className={undefined} size={undefined} height={undefined} defualtWidth={undefined} />
                  <span className="text-sm text-[#4D4D4D]">
                    {item?.field} :{" "}
                  </span>
                </div>
                <h3 className="text-[#4D4D4D] text-sm font-bold">
                  {new Date(item?.value).toLocaleDateString()}
                </h3>
              </div>
            ) : item?.fieldType === 12 ? (
              <div className="grid grid-cols-2">
                <div className="flex items-center gap-3">
                  <Image width={18} id={item?.fieldGalleryId} alt="car" className={undefined} size={undefined} height={undefined} defualtWidth={undefined} />
                  <span className="text-sm text-[#4D4D4D]">
                    {item?.field} :{" "}
                  </span>
                </div>
                <h3 className="text-[#4D4D4D] text-sm font-bold">
                {String(new Date(item?.value).getHours()).padStart(2, "0")} :{" "}
          {String(new Date(item?.value).getMinutes()).padStart(2, "0")}
                </h3>
              </div>
            )  : (
              <></>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default AdInfo;
